var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.56 0.07C0.45 0.11 0.35 0.18 0.26 0.27C0.18 0.35 0.11 0.45 0.06 0.57C0.02 0.68 0 0.8 0 0.92C0 1.04 0.02 1.16 0.06 1.27C0.11 1.39 0.18 1.49 0.26 1.57L10.53 12L0.26 22.42C0.09 22.59 0 22.83 0 23.07C0 23.32 0.09 23.55 0.26 23.72C0.43 23.9 0.66 24 0.91 24C1.15 24 1.38 23.9 1.55 23.72L12.46 12.65C12.54 12.56 12.61 12.46 12.65 12.35C12.7 12.24 12.72 12.12 12.72 12C12.72 11.87 12.7 11.75 12.65 11.64C12.61 11.53 12.54 11.43 12.46 11.34L1.55 0.27C1.46 0.18 1.36 0.11 1.25 0.07C1.14 0.02 1.03 0 0.91 0C0.79 0 0.67 0.02 0.56 0.07ZM7.83 0.07C7.72 0.11 7.62 0.18 7.53 0.27C7.45 0.35 7.38 0.45 7.34 0.57C7.29 0.68 7.27 0.8 7.27 0.92C7.27 1.04 7.29 1.16 7.34 1.27C7.38 1.39 7.45 1.49 7.53 1.57L17.8 12L7.53 22.42C7.36 22.59 7.27 22.83 7.27 23.07C7.27 23.32 7.36 23.55 7.53 23.72C7.7 23.9 7.94 24 8.18 24C8.42 24 8.65 23.9 8.82 23.72L19.73 12.65C19.81 12.56 19.88 12.46 19.93 12.35C19.97 12.24 20 12.12 20 12C20 11.87 19.97 11.75 19.93 11.64C19.88 11.53 19.81 11.43 19.73 11.34L8.82 0.27C8.74 0.18 8.64 0.11 8.53 0.07C8.42 0.02 8.3 0 8.18 0C8.06 0 7.94 0.02 7.83 0.07Z",
    fill: "#00A03C",
    fillOpacity: 1,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowExpand);
export default __webpack_public_path__ + "static/media/arrow-expand.d5df9b38f17a35b2f87acdac960c906f.svg";
export { ForwardRef as ReactComponent };